import styled from "styled-components";

export const DropdownContainer = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: start;
  gap: 12px;
  width: 100%;
`;

export const DropdownTitle = styled.div`
  display: flex;
  align-items: start;
  justify-content: space-between;
  cursor: pointer;
  width: 100%;
`;

export const DropdownContent = styled.div<{ $expanded: boolean }>`
  overflow: hidden;
  display: ${({ $expanded }) => ($expanded ? "flex" : "none")};
  flex-direction: column;
  justify-content: center;
  width: 100%;
`;
